import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("multi-column", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateMultiColumn = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateMultiColumn?.destroy();
  },
});
